import { Spacings, View } from "react-native-ui-lib";
import { SkeletonBadge, SkeletonView } from "../../../../components";

export interface SaleResourceListItemSkeletonProps {}

export const SaleResourceListItemSkeleton = () => {
  return (
    <View flex row style={{ justifyContent: "space-between" }}>
      <View style={{ width: "60%" }}>
        <SkeletonView textVariant="heading" width={120} />
        <SkeletonView textVariant="heading4" width={160} />
      </View>
      <View row style={{ alignItems: "flex-end" }}>
        <View style={{ alignItems: "flex-end" }}>
          <SkeletonView textVariant="heading1" />

          <View row style={{ marginLeft: Spacings.s2 }}>
            <SkeletonBadge />
          </View>
        </View>
        <View>
          <SkeletonView style={{ width: 24, height: 24 }} />
        </View>
      </View>
    </View>
  );
};
